import { transformReportAggregationItself } from '@bingads-webui-campaign/reports-v4-schema';

export const isDeprecatedDimensionReport = (entityType) => {
  const dimensionReportsEntity = [
    'AgeAndGender ',
    'CallForwardingDetail',
    'PublisherWebsite',
    'SearchTerms',
    'ShoppingBrand',
    'ShoppingCategory',
    'ShoppingItemId',
    'ShoppingProductType',
    'ShoppingStoreId',
  ];

  return dimensionReportsEntity.includes(entityType);
};

export function transformTaskItem(oldTaskItem) {
  // if is task item is in new schema, just return it
  if (oldTaskItem.IsPreview) {
    return oldTaskItem;
  }

  const newTaskITem = transformReportAggregationItself(oldTaskItem);
  return newTaskITem;
}
